import BranchesComponent from '../components/branches/branches'

const Branches = () => <BranchesComponent />

export default Branches;